import React, { useState } from "react";
import { Star, X } from "lucide-react";

export const TRUSTPILOT_REVIEW_URL = "https://www.trustpilot.com/evaluate/shadowspeakjournal.com";
const KEY = "umbra_tp_ask_done";

// Gentle, one-time review ask after a chapter is complete.
export default function TrustpilotAsk({ chapterId }) {
  const [hidden, setHidden] = useState(() => {
    try {
      return window.localStorage.getItem(KEY) === "1";
    } catch {
      return false;
    }
  });
  if (hidden) return null;
  const done = () => {
    try {
      window.localStorage.setItem(KEY, "1");
    } catch {
      /* storage disabled */
    }
    setHidden(true);
  };
  return (
    <aside className="relative mt-10 border border-terracotta/40 bg-obsidian-800/60 p-5 flex flex-col sm:flex-row sm:items-center gap-4 animate-fade-up" data-testid="trustpilot-ask">
      <div className="flex-1 pr-8 sm:pr-0">
        <p className="font-serif text-lg text-bone-100">You finished this chapter.</p>
        <p className="font-sans text-sm text-bone-400 leading-relaxed">If Umbra helped, a short review on Trustpilot helps the next person find it. Never about your answers — those stay private.</p>
      </div>
      <a
        href={`${TRUSTPILOT_REVIEW_URL}?utm_source=umbra&utm_medium=chapter_complete&utm_campaign=${chapterId}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={done}
        data-testid="trustpilot-ask-link"
        className="inline-flex items-center gap-2 border border-terracotta text-bone-100 hover:bg-terracotta hover:text-obsidian-900 px-5 min-h-[44px] font-sans text-xs uppercase tracking-[0.22em] transition-colors"
      >
        <Star className="h-4 w-4" /> Review on Trustpilot
      </a>
      <button onClick={done} aria-label="Dismiss" data-testid="trustpilot-ask-dismiss" className="absolute top-2 right-2 sm:static text-bone-500 hover:text-bone-100 p-2">
        <X className="h-4 w-4" />
      </button>
    </aside>
  );
}
